import React from 'react';
import { Link } from 'react-router';
import PropTypes from 'prop-types';
import CollectionMenu from './collection_menu.ui.jsx';

const isCollectionOpen = props =>
    props.collection.content.length > 0 &&
    props.query.section === String(props.section.id) &&
    props.query.collection === props.collection.name;

export default class Collection extends React.Component {
    static displayName = 'Collection';

    static propTypes = {
        query: PropTypes.object.isRequired,
        canEdit: PropTypes.bool.isRequired,
        collection: PropTypes.shape({
            name: PropTypes.string.isRequired,
            content: PropTypes.any.isRequired,
        }).isRequired,
        section: PropTypes.shape({
            id: PropTypes.number.isRequired,
        }).isRequired,
        deleteCollection: PropTypes.func.isRequired,
        setOrigin: PropTypes.func.isRequired,
        push: PropTypes.func.isRequired,
        addAural: PropTypes.func.isRequired,
    };

    componentDidUpdate(prevProps, prevState) {
        const {
            collection: { name },
            addAural,
        } = this.props;
        const isOpen = isCollectionOpen(this.props);
        const wasOpen = isCollectionOpen(prevProps);
        if (wasOpen && !isOpen) {
            this.collectionTile.focus && this.collectionTile.focus();
        }
        if (isOpen !== wasOpen) {
            addAural(`Collection ${name} is ${isOpen ? 'open' : 'closed'}`);
        }
    }

    captureCollectionRef = node => {
        this.collectionTile = node;
    };

    setCollectionOrigin = () => {
        this.props.setOrigin();
    };

    renderInternal() {
        const {
            collection: { name, content },
        } = this.props;
        const numItems = content.length;

        return (
            <div>
                <h3 className="aural">Open collection: {name}</h3>
                <div
                    key="label"
                    className="collection-label"
                    aria-hidden="true"
                >
                    Collection
                </div>
                <div key="title" className="title">
                    <span aria-hidden="true">{name}</span>
                </div>
                <div key="counts" className="material-tally">
                    <span className="material-count">
                        <span className="aural">Materials in collection: </span>
                        {numItems + ' Materials'}
                    </span>
                </div>
            </div>
        );
    }

    render() {
        const { section, collection, deleteCollection, push } = this.props;
        const { name, content } = collection;
        const numItems = content.length;

        let internal;
        if (numItems > 0) {
            const query = {
                section: section.id.toString(),
                collection: name,
            };
            const currentQuery = this.props.query;

            if (
                currentQuery.section === query.section &&
                currentQuery.collection === query.collection
            ) {
                query.section = undefined;
                query.collection = undefined;
            }

            const pathname = `term/${section.term_id}`;
            internal = (
                <Link
                    to={{ pathname, query }}
                    className="collection-metadata js-collection-item"
                    innerRef={this.captureCollectionRef}
                >
                    {this.renderInternal()}
                </Link>
            );
        } else {
            internal = (
                <div className="collection-metadata js-collection-item">
                    {this.renderInternal()}
                </div>
            );
        }

        return (
            <div className="js-collection column collection">
                {internal}
                <CollectionMenu
                    isInstructor={this.props.canEdit}
                    section={section}
                    collection={collection}
                    deleteCollection={deleteCollection}
                    push={push}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/section/collection.jsx